export default {
  init() {
    // JavaScript to be fired on the home page
  },
	finalize() {
		$('.blog-slider').slick({
		  dots: true,
		  arrows: false,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  adaptiveHeight: true
		});
		$('.our_mission_slider').slick({
		  dots: true,
		  arrows: true,
		  infinite: true,
		  speed: 500,
		  slidesToShow: 1,
		  adaptiveHeight: true
		});	
		$('.service_1').css('opacity', '1');  		
		$(".who_we_serve h3").hover( function() {
			$('.'+$(this).attr('id')).css('opacity', '1');
		  }, function() {
			$('.'+$(this).attr('id')).css('opacity', '0');
			$('.service_1').css('opacity', '1');  
		  }
		);
		
		$('.next-scrol').on('click', function(event) {
			var target = $(this.getAttribute('href'));
			if( target.length ) {
				event.preventDefault();
				$('html, body').stop().animate({
					scrollTop: target.offset().top-131
				}, 1000);
			}
		});
},
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js